// components/GuestRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import CryptoJS from "crypto-js";

const GuestRoute = ({ children }) => {
  // const token = Cookies.get("token");
  const token = sessionStorage.getItem("token");
  const [searchParams] = useSearchParams();
  const accessKey = searchParams.get("key");

  const today = new Date().toISOString().split("T")[0];

  const key = `${today}-` + process.env.REACT_APP_URI_KEY;
  const md5Hash = CryptoJS.MD5(key).toString();

  // console.log("Access Key:", accessKey);
  // console.log("MD5 Hash:", md5Hash);

  if (!accessKey) {
    //abort 404
    return <Navigate to="/404" replace />;
  }
  if (accessKey !== md5Hash) {
    //abort 404
    return <Navigate to="/404" replace />;
  }

  if (token) {
    // Kalau sudah login, redirect ke homepage
    return <Navigate to="/" replace />;
  }

  return children;
};

export default GuestRoute;
